(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["booking-form"]) return;
  try {
    
  if (!customElements.get('booking-form-popups')) {
    customElements.define('booking-form-popups', class extends HTMLElement {
      connectedCallback() {
        if (this.popupEvents) return;
        this.popupEvents = new AbortController();
        const options = { signal: this.popupEvents.signal };

        this.addEventListener('pointerdown', (event) => {
          this.backdropPressed = this.isBackdrop(event);
        }, options);

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const dialog = event.target.closest('dialog.sky-booking-popup[open]');
          if (!dialog) return;
          const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')]
            .filter((element) => element.tabIndex >= 0 && element.getClientRects().length);
          const first = focusable[0];
          const last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first || !event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            (event.shiftKey ? last : first)?.focus();
          }
        }, options);

        this.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-booking-popup-open]');
          if (trigger) {
            const dialog = document.getElementById(trigger.dataset.bookingPopupOpen);
            if (dialog && this.contains(dialog) && !dialog.open) dialog.showModal();
            return;
          }

          const closeButton = event.target.closest('[data-booking-popup-close]');
          if (closeButton) {
            closeButton.closest('dialog').close();
          } else if (this.backdropPressed && this.isBackdrop(event)) {
            event.target.close();
          }
          this.backdropPressed = false;
        }, options);
      }

      isBackdrop(event) {
        if (!event.target.matches('dialog.sky-booking-popup')) return false;
        const bounds = event.target.getBoundingClientRect();
        return event.clientX < bounds.left || event.clientX > bounds.right ||
          event.clientY < bounds.top || event.clientY > bounds.bottom;
      }

      disconnectedCallback() {
        this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
        this.popupEvents?.abort();
        this.popupEvents = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
